import * as React from "react";

import { useFormSubmissionContext } from "@brexhq/next/src/components/modules/LeadForm/FormSubmissionProvider";
import { useLeadFormModuleContext } from "@brexhq/next/src/components/modules/LeadForm/LeadFormModuleProvider";
import { GTMFormPageTemplate } from "@brexhq/next/src/components/modules/LeadForm/Steps/PageTemplates/GTMFormPageTemplate";
import { LeadFormSteps } from "@brexhq/next/src/components/modules/LeadForm/machines/types";
import { LeadFormValues } from "@brexhq/next/src/components/modules/LeadForm/sharedTypes";

import { employeeGreaterThan50 } from "../../machines/helpers";

export const GTMExistingLead: React.FC = () => {
  const {
    submit,
    form: { getValues },
  } = useFormSubmissionContext();

  const {
    customExistingLeadSubmitButtonLabel,
    customProgramName,
    customExistingLeadFormTitle,
  } = useLeadFormModuleContext();

  const fieldList: (keyof LeadFormValues)[] = React.useMemo(() => {
    let list = [
      "firstName",
      "lastName",
      "companyName",
      "mobileNumber",
      "employeeCount",
    ];

    const employeeCount = getValues().employeeCount;

    if (!employeeGreaterThan50(employeeCount)) {
      list = list.concat(["isEcomm", "monthlySales", "fundingSources"]);
    }

    return list as (keyof LeadFormValues)[];
  }, [getValues]);

  const onSubmit = React.useCallback(
    async (event) => {
      /**
       * Handles form submission including validations.
       * Reference FormSubmissionProvider.tsx for more context
       */
      submit({
        event,
        fields: fieldList,
        prevStep: LeadFormSteps.gtmExistingLead,
      });
    },
    [fieldList, submit],
  );

  return (
    <GTMFormPageTemplate
      title={customExistingLeadFormTitle ?? "Welcome back"}
      step={LeadFormSteps.gtmExistingLead}
      programName={customProgramName}
      nextAction={{
        label: customExistingLeadSubmitButtonLabel ?? "Access content",
        disabled: false,
        loading: false,
        onClick: onSubmit,
      }}
      confirmationOnly
    />
  );
};
